module.exports = __webpack_public_path__ + "static/media/amex_card.f605d933.jpg";